import { render, staticRenderFns } from "./confirmedTrip.vue?vue&type=template&id=fc148b60&"
import script from "./confirmedTrip.vue?vue&type=script&lang=js&"
export * from "./confirmedTrip.vue?vue&type=script&lang=js&"
import style0 from "./confirmedTrip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "confirmedTrip.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
